import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { isNullOrUndefined } from '../../../extensions/object/object.detect.extensions';
import { ListColumnHeaderSortEvent } from './events/sort.event';

@Component({
    selector: 'ig-list-column-header',
    templateUrl: './list.column.header.component.html',
    styleUrls: ['./list.column.header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class]': 'class'
    }
})
export class ListColumnHeaderComponent {
    @Input() public class: string;
    @Input() public sortable = false;
    @Input() public isAsc: boolean;
    @Output() public onSort = new EventEmitter<ListColumnHeaderSortEvent>();

    public get isSortedOnce() {
        return !isNullOrUndefined(this.isAsc);
    }

    public sort() {
        if (this.sortable) {
            if (!this.isSortedOnce) {
                this.isAsc = true;
            } else {
                this.isAsc = !this.isAsc;
            }

            this.onSort.emit(new ListColumnHeaderSortEvent(this, this.isAsc));
        }
    }

    public clearSortStatus() {
        this.isAsc = null;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/list/column.header/list.column.header.component.ts